import React, { useState, useEffect } from 'react'

import { useParams } from 'react-router-dom'

import 'web_common/css/LimnTech.css'
import { db } from 'web_common/tsx/api/db/Api'
import { Company, CompanyAdminPrivilege, LifemarkUserModel, ImportedPath, AuthToken } from 'web_common/tsx/api/db/Models'
import PreviewPathForm from 'web_common/tsx/components/import/PreviewPathForm'
import ApiError from 'web_common/tsx/components/misc/ApiError'
import PermissionDenied from 'web_common/tsx/components/misc/PermissionDenied'
import Loading from 'web_common/tsx/components/misc/Loading'

import { urls } from 'InternalUrls'

interface PreviewImportedPathProps {

}

const PreviewImportedPath: React.FC<PreviewImportedPathProps> = (props) => {
    const { company_id, import_id } = useParams()

    const [apiError, setApiError] = useState<boolean>(false)
    const [lifemarkUser, setLifemarkUser] = useState<LifemarkUserModel|undefined>(undefined)
    const [company, setCompany] = useState<Company|undefined>(undefined)
    const [importedPath, setImportedPath] = useState<ImportedPath|undefined>(undefined)
    const [userToken, setUserToken] = useState<AuthToken|undefined>(undefined)

    useEffect(() => {
        const onCurrentUser = (response: LifemarkUserModel|undefined) => {
            if(response === undefined)
            {
                setApiError(true)
            }
            else
            {
                setLifemarkUser(response)
            }
        }

        db.current_user(onCurrentUser)
    }, [])

    useEffect(() => {
        if(company_id !== undefined)
        {
            const onCompany = (response: Company|undefined) => {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setCompany(response)
                }
            }

            db.company_detail(company_id, onCompany)
        }
    }, [company_id])

    useEffect(() => {
        if(lifemarkUser !== undefined && import_id !== undefined)
        {
            let onResponse = (response: ImportedPath|undefined) =>
            {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setImportedPath(response)
                }
            }

            db.imported_path_detail(
                import_id,
                onResponse)
        }
    }, [lifemarkUser, import_id])

    useEffect(() => {
        if(lifemarkUser !== undefined)
        {
            let onResponse = (response: AuthToken|undefined) =>
            {
                if(response === undefined)
                {
                    setApiError(true)
                }
                else
                {
                    setUserToken(response)
                }
            }

            db.auth_token(onResponse)
        }
    }, [lifemarkUser])

    if(apiError === true)
    {
        return <ApiError/>
    }
    else if(lifemarkUser !== undefined)
    {
        if(lifemarkUser.privilege === CompanyAdminPrivilege.NONE)
        {
            return (
                <PermissionDenied/>
            )
        }
        else if(lifemarkUser.privilege === CompanyAdminPrivilege.USER)
        {
            return (
                <PermissionDenied/>
            )
        }
        else if(company !== undefined && importedPath !== undefined && userToken !== undefined)
        {
            return (
                <div className='limn-form-container'>
                    <h1 className='limn-header'> Path Import </h1>
                    <PreviewPathForm
                        company={company}
                        path={importedPath}
                        token={userToken}
                        getImportSuccessUrl={urls.getImportSuccess}
                        getImportFailureUrl={urls.getImportFailure}
                    />
                </div>
            )
        }
        else
        {
           return (
                <div className='limn-form-container'>
                    <h1 className='limn-header'> Path Import </h1>
                    <Loading/>
                </div>
            )
        }
    }
    else
    {
        return (
            <div className='limn-form-container'>
                <h1 className='limn-header'> Path Import </h1>
                <Loading/>
            </div>
        )
    }
}

export default PreviewImportedPath
